import { IFavorite } from 'models/Favorite'
import { IError, IPayload } from 'models/Global'
import { IShift } from 'models/Shift'
import { action, payload } from 'ts-action'

interface IUpdateFeaturedShiftsApplicants {
  applicants: {
    pending_count: number
    accepted_count: number
    confirmed_count: number
  }
  shiftId: number
}

export const FeaturedShiftsFetching = action(
  'FeaturedShiftsFetching',
  payload<boolean>(),
)

export const GetFeaturedShifts = action(
  'GetFeaturedShifts',
  payload<IPayload<IShift[]>>(),
)

export const GetFeaturedShiftsWithoutConcat = action(
  'GetFeaturedShiftsWithoutConcat',
  payload<IPayload<IShift[]>>(),
)

export const GetFeaturedShiftsErrors = action(
  'GetFeaturedShiftsErrors',
  payload<IError>(),
)

export const ClearFeaturedShiftsReducer = action('ClearFeaturedShiftsReducer')

export const UpdateFeaturedShiftApplicants = action(
  'UpdateFeaturedShiftApplicants',
  payload<IUpdateFeaturedShiftsApplicants>(),
)

export const FeaturedShiftsUnfavoriteBusiness = action(
  'FeaturedShiftsUnfavoriteBusiness',
  payload<number>(),
)

export const FeaturedShiftsFavoriteBusiness = action(
  'FeaturedShiftsFavoriteBusiness',
  payload<IFavorite>(),
)

export const FeaturedShiftsSetHasMore = action(
  'FeaturedShiftsSetHasMore',
  payload<boolean>(),
)
